export default "__VITE_ASSET__269d78a9__"